function findByTag(vnode, tag) {
  if (!vnode) return null
  if (tag.test(vnode.tag)) return vnode
  return findByTag(vnode.parent, tag)
}

function findParentDom(ele, match) {
  if (!ele) return null
  if (match(ele)) return ele
  return findParentDom(ele.parentElement, match)
}

export default {
  name: 'dropdown-mask',
  // 只调用一次，指令第一次绑定到元素时执行
  bind(el, binding, vnode) {
    let vTrigger = findByTag(vnode, /-Trigger/g)
    if (!vTrigger) throw new Error('trigger not found')

    const vm = vTrigger.parent.componentInstance
    vm.afterVisibleChangeBak = vm.afterVisibleChange
    vm.afterVisibleChange = function(visible) {
      vm.afterVisibleChangeBak(visible)

      //console.log(visible);
      let overlay = vm.getPopupDomNode();
      let mask = findParentDom(overlay, a => a.parentElement?.tagName == 'BODY')
      setTimeout(() => {
        if(visible) mask.classList.add('dropdown-visible')
        else mask.classList.remove('dropdown-visible')
      }, visible ? 10 : 300)
    }
  },
};